<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaStatusOdontograma"
        title-table="Status Odontograma"
        module="statusOdontogramaSettingsModule"
        sort-name="descricao"
        :show-btn-add="verificarPermissao('ROLE_ATEND_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_ATEND_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <FormStatusOdontograma v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import { verificarPermissao } from "@/auth/utils";
import FormStatusOdontograma from "./forms/FormStatusOdontograma.vue";

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormStatusOdontograma,
  },
  computed: {
    ...mapState("statusOdontogramaSettingsModule", {
      listaStatusOdontograma: (state) => state.listaStatusOdontograma,
    }),
  },
  data() {
    return {
      verificarPermissao,
      showForm: false,
      columns: [
        {
          label: "Id",
          field: "id",
        },
        {
          label: "Nome",
          field: "nome",
        },
        {
          label: "Descrição",
          field: "descricao",
        },
        {
          label: "Ativo",
          field: "ativo",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      pageConfig: {
        page: 1,
        size: 10,
        sort: "nome",
        order: "asc",
      },
    };
  },
  methods: {
    addNew() {
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch(
        "statusOdontogramaSettingsModule/prepareToEdit",
        data
      );
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
    },
  },
};
</script>
